import { render, staticRenderFns } from "./BoardManager.vue?vue&type=template&id=12753a62&"
import script from "./BoardManager.vue?vue&type=script&lang=js&"
export * from "./BoardManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports